module.exports = function (app, mod) {
  return "\n    <div class=\"saito-overlay-form-text\">\n      <p>No advanced emulator options are configured for this module yet.</p>\n    </div>\n  ";
};